
import Header from "../Home/header";
import Footer from "../Home/footer";
import ProductList from "../Products/productLists";

export function Products() {

    return (
        <div>
            <Header />
            <ProductList />
            <Footer />
        </div>
    );
}

export default Products;
